export class CustomExportDataRequestDto {
  public customExportFieldGroupID: string;
  public fields: string[];
  public jobID: string;
  public dateFrom: string;
  public dateTo: string;
}
